import React, { Component, Fragment } from "react";
import AUX from "../../../hoc/Aux_";
import { connect } from "react-redux";
import PermissionAction from "../../../store/permission/action";
import "../../../assets/css/TeamStyle.css";
import _ from "lodash";
import { MDBInput } from "mdbreact";
import Services from "../PermissionService";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import $ from "jquery";
import axios from "../../Shared/auth-header";
import { toast } from "react-toastify";
import PermissionAlgo from "./PermissionAlgo";

class EditLinkedPositionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      teamId: -1,
      positionName: "",

      heading: "",
    };
    this.cancelModal = this.cancelModal.bind(this);
    this.saveModal = this.saveModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.positionConfiguration = this.positionConfiguration.bind(this);
    this.handleChangePositionName = this.handleChangePositionName.bind(this);
  }
  cancelModal = async () => {
    this.setState({
      teamId: -1,
      positionName: "",
      openModal: false,
    });
    //  window.$("#" + this.state.heading).modal("hide");
  };

  async saveModal() {
    $(".loading").show();

    if (
      PermissionAlgo.notNullValidation(this.state.positionName) == null &&
      PermissionAlgo.textValidation(this.state.positionName) == ""
    ) {
      toast.success("position edited successfully!");
      this.props.saveLinkedPositionName({
        positionName: this.state.positionName,
        teamId: this.props.teamId,
      });

      this.cancelModal();
    } else {
      toast.error("Please enter a valid position name!");
    }
    $(".loading").hide();
  }

  componentDidUpdate(prevProps) {
    if (this.props.openModal && this.props.teamId != this.state.teamId) {
      this.setState({
        positionName: this.props.positionName,
        teamId: this.props.teamId,
        openModal: this.props.openModal,
        heading: this.props.heading,
      });
      this.openModal();
    }
  }

  openModal() {
    this.props.closeModal();
  }
  saveCancelButton = () => {
    return (
      <Fragment>
        <div className="row pt-2">
          <div className="col-12">
            <div className="text-right">
              <button
                className="btn btn-danger btn-x-sm btn-sm w-md waves-effect waves-light"
                type="button"
                onClick={this.cancelModal}
              >
                Cancel
              </button>
              <button
                onClick={this.saveModal}
                className="btn btn-success btn-x-sm btn-sm ml-2 w-md waves-effect waves-light"
                type="submit"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };
  handleChangePositionName = (e) => {
    this.state.positionName = e.target.value;
    let error = PermissionAlgo.notNullValidation(e.target.value);
    if (!error) {
      error = PermissionAlgo.textValidation(e.target.value);
    }
    this.state.positionName_err = error;

    this.setState({
      positionName: this.state.positionName,
    });
  };
  positionConfiguration = () => {
    return (
      <div className="row">
        <div className="col-12">
          <span className="card-subtitle align-self-end pr-1 mb-2 text-secondary">
            Position Name:
          </span>
          <MDBInput
            containerClass="mt-2 mb-2"
            className="py-0 mb-0"
            name="PositionName"
            value={this.state.positionName}
            onChange={this.handleChangePositionName}
            hint="provide your position Name"
            type="text"
          />

          <span className="text-danger">{this.state.positionName_err}</span>
        </div>
      </div>
    );
  };
  render() {
    return (
      <div
        className={`modal fade confirm-modal p-0  ${
          this.state.openModal ? " show d-block" : ""
        }`}
        style={{ zIndex: "1100" }}
        role="dialog"
        id={this.props.heading}
        aria-labelledby=""
        aria-hidden="true"
      >
        <div className={"modal-dialog modal-dialog-centered modal-sm"}>
          <div className="modal-content shadow">
            <div className="modal-header small text-uppercase bg-secondary py-2">
              <h5 className="modal-title text-white mt-0">
                Linked Position Name
              </h5>
              <button
                type="button"
                class="close text-white"
                onClick={this.cancelModal}
              >
                <span>&times;</span>
              </button>
            </div>

            <div className="modal-body py-3">
              {this.positionConfiguration()}
              {this.saveCancelButton()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditLinkedPositionModal;
